import type { AccessibilityProps } from 'react-native'
import { Button } from '~/components/button'

interface ModalClosableButtonProps extends AccessibilityProps {
  onPress?: () => void
  testID?: string
}

export function ModalClosableButton({
  onPress,
  testID,
}: ModalClosableButtonProps) {
  return (
    <Button.Root
      testID={testID}
      variant="neutral-tertiary"
      size="lg"
      onPress={onPress}
    >
      <Button.Icon symbol="rdicon-dismiss" />
    </Button.Root>
  )
}
